import { synchronizationConstant } from 'actionTypes';
import {
  Document,
  FetchConnectionRequestedPayload,
  FetchDocumentListRequestPayload,
  FetchDocumentListSuccessPayload,
  FetchProjectListRequestPayload,
  FetchProjectListSuccessPayload,
  UpdateCurrentConnectionPayload,
  UpdateCurrentFolderPayload,
  UpdateCurrentProjectPayload,
  UpdateSyncDocumentStatusPayload,
} from 'types/actions/synchronization';

export const fetchConnectionList = () => {
  return {
    type: synchronizationConstant.CONNECTIONS_FETCH_REQUESTED,
  };
};

export const fetchConnectionListSuccess = (payload: FetchConnectionRequestedPayload) => {
  return {
    type: synchronizationConstant.CONNECTIONS_FETCH_SUCCEEDED,
    payload,
  };
};

export const fetchProjectList = (payload: FetchProjectListRequestPayload) => {
  return {
    type: synchronizationConstant.PROJECTS_FETCH_REQUESTED,
    payload,
  };
};

export const fetchProjectListSuccess = (payload: FetchProjectListSuccessPayload) => {
  return {
    type: synchronizationConstant.PROJECTS_FETCH_SUCCEEDED,
    payload,
  };
};

export const fetchProjectListLoading = (payload: boolean) => {
  return {
    type: synchronizationConstant.PROJECTS_FETCH_LOADING,
    payload,
  };
};

export const fetchDocumentListByProject = (payload: FetchDocumentListRequestPayload) => {
  return {
    type: synchronizationConstant.DOCUMENT_FETCH_REQUESTED,
    payload,
  };
};

export const fetchDocumentListSuccess = (payload: FetchDocumentListSuccessPayload) => {
  return {
    type: synchronizationConstant.DOCUMENT_FETCH_SUCCEEDED,
    payload,
  };
};

export const fetchDocumentListLoading = (payload: boolean) => {
  return {
    type: synchronizationConstant.DOCUMENT_FETCH_LOADING,
    payload,
  };
};

export const updateCurrentConnection = (payload: UpdateCurrentConnectionPayload) => {
  return {
    type: synchronizationConstant.UPDATE_CURRENT_CONNECTION,
    payload,
  };
};

export const updateCurrentProject = (payload: UpdateCurrentProjectPayload) => {
  return {
    type: synchronizationConstant.UPDATE_CURRENT_PROJECT,
    payload,
  };
};

export const updateCurrentFolder = (payload: UpdateCurrentFolderPayload) => {
  return {
    type: synchronizationConstant.UPDATE_CURRENT_FOLDER,
    payload,
  };
};

export const updateCurrentSelectedFolders = (payload: Document) => {
  return {
    type: synchronizationConstant.UPDATE_CURRENT_SELECTED_FOLDERS,
    payload,
  };
};

export const syncDocumentRequest = () => {
  return {
    type: synchronizationConstant.SYNC_DOCUMENT_REQUESTED,
  };
};

export const updateSyncDocumentStatus = (payload: UpdateSyncDocumentStatusPayload) => {
  return {
    type: synchronizationConstant.UPDATE_SYNC_DOCUMENT_STATUS,
    payload,
  };
};

export const syncDocumentProcessing = (payload: boolean) => {
  return {
    type: synchronizationConstant.SYNC_DOCUMENT_PROCESSING,
    payload,
  };
};

export const resetProject = () => ({
  type: synchronizationConstant.RESET_PROJECT,
});

export const resetSyncProject = () => ({
  type: synchronizationConstant.RESET_SYNC_PROJECT,
});

